export default __webpack_public_path__ + "14456e9d0406b65c842666cf89ad76ee.svg";